module.exports = __webpack_public_path__ + "img/whatsapp.ac4a6ef1.svg";